import shortcode from "./shortcode.js";
import drawers from "./drawers.js";
import countup from "./countup.js";
import gallery from "./gallery.js";

jQuery(document).ready(function ($) {


    shortcode();
    drawers();
    countup();
    gallery();

    const scrollThreshold = 15 + jQuery('.header__main').outerHeight();

    jQuery(document).on('scroll', function () {
        if (jQuery(window).scrollTop() >= scrollThreshold) {
            jQuery('.header__main').addClass('is-scrolled');
        } else if (jQuery(window).scrollTop() < (scrollThreshold - 25)) {
            jQuery('.header__main').removeClass('is-scrolled');
        }
    });

    const paginationContainer = document.querySelector(".block__hero-pagination");
    const mainContainer = document.querySelector(".block__hero-swiper");
    const slideCount = mainContainer?.querySelectorAll('.swiper-slide').length || 0;

    if (slideCount > 1) {
        const paginationSwiper = new Swiper(".block__hero-pagination", {
            spaceBetween: 8,
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
        });

        const mainSwiper = new Swiper(".block__hero-swiper", {
            spaceBetween: 0,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            // Bullets are only shown on mobile (see _hero.scss), where the
            // title-tab pagination is hidden and swiping isn't obvious.
            pagination: {
                el: ".block__hero-bullets",
                clickable: true,
            },
            thumbs: {
                swiper: paginationSwiper,
            },
            on: {
                init: function () {
                    startTimer(this);
                },
                slideChangeTransitionStart: function () {
                    resetTimers();
                    startTimer(this);
                },
            },
        });

        function startTimer(swiper) {
            const activeSlide = paginationSwiper.slides[swiper.activeIndex];
            const timer = activeSlide?.querySelector('.timer span');
            if (timer) {
                timer.style.animation = 'none';
                setTimeout(() => {
                    timer.style.animation = 'progress 5s linear forwards';
                }, 10);
            }
        }

        function resetTimers() {
            paginationSwiper.slides.forEach(slide => {
                const timer = slide.querySelector('.timer span');
                if (timer) timer.style.animation = 'none';
            });
        }
    }
    else {
        const mainSwiper = new Swiper(".block__hero-swiper", {
            spaceBetween: 0,
            slidesPerView: 1,
        });
    }

    // Donation totals/progress are rendered server-side, so the slides are
    // already in the DOM — only the swiper needs initialising.
    if (document.querySelector('.block__projectdonations-swiper')) {
        new Swiper('.block__projectdonations-swiper', {
            direction: "vertical",
            slidesPerView: "auto",
        });
    }


    jQuery('.faq__item').on('click', 'summary', function(e) {
        e.preventDefault();
        const $item = $(this).parent();
        const $answer = $item.find('.faq__answer');
        const $svg = $item.find('svg');
        const isOpen = $item.prop('open');

        if (isOpen) {
            $answer.stop().animate({ height: '0' }, 300, function() {
                $item.removeAttr('open');
            });

        } else {
            $item.attr('open', '');
            const height = $answer[0].scrollHeight;
            $answer.css('height', '0').stop().animate({ height: height + 'px' }, 300);
        }

        $svg.toggleClass('is-active');

    });

});